// 参比制剂（RLD）采购申请表

import { Form } from "antd";
import { ApplicationInfoFormFields } from "./ApplicationInfoFormFields";
import { SpecialRequirementFormFields } from "./SpecialRequirementFormFields";
import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import type { PurchaseRequestFormProps } from "../../type";
import { useFormEditable } from "../../hooks/useFormEditable";
import { SupplierInfoFormFields } from "./SupplierInfoFormFields";
import { useModal } from "@/hooks/modals/useModal";
import { usePurchaseRequestDetail } from "../../hooks/usePurchaseRequest";
import { OrderConfrimFormFields } from "../OrderConfrimFormFields";
import { useExistFlowHistory } from "@/hooks/services/useFlow";
import {
  fillInPONodeCodes,
  purchaseManagerAuditNodeCodesForRLD,
} from "../../constant";

export const RldReferenceProductRequisitionForm = ({
  form,
}: PurchaseRequestFormProps) => {
  const { props } = useModal("PURCHASE_REQUEST");
  const { recordId } = props;

  const detail = usePurchaseRequestDetail(recordId);
  const { isMainFormDisabled } = useFormEditable();

  const shouldShowSupplierInfo = useExistFlowHistory(
    purchaseManagerAuditNodeCodesForRLD,
    detail?.insId,
  );

  const shouldShowOrderConfirm = useExistFlowHistory(
    fillInPONodeCodes,
    detail?.insId,
  );

  return (
    <Form layout="vertical" disabled={isMainFormDisabled} form={form}>
      <UserFormFields />
      {/* 申请信息 */}
      <ApplicationInfoFormFields />
      {/* 特别要求 */}
      <SpecialRequirementFormFields />

      {/* 供应商信息 */}
      {shouldShowSupplierInfo && <SupplierInfoFormFields />}

      {/* 订单确认 */}
      {shouldShowOrderConfirm && <OrderConfrimFormFields />}
    </Form>
  );
};
